<template>
    <div class="newDetail_liul padding80">
        <Header :current="2"></Header>
        <div class="contents">
            <div class="title">徕檬——让金融和商业生态更智慧、更温馨</div>
            <div class="time">2021-07-30 </div>
            <div class="content" style="font-weight: bold">公司简介</div>
            <div class="content2">杭州徕檬是一家致力于金融企业数字化转型和移动互联网、人工智能赋能金融生态圈的创新型企业。</div>
            <div class="content2">公司核心团队有着多年金融行业和移动互联网行业的从业经验，对银行业数字化运营发展历程有着深刻的理解，面向Bank4.0时代帮助客户打造移动化银行、数字化银行、场景银行、智能银行。徕檬自成立以来，已先后与台州银行、阿里云、蚂蚁金服、华夏银行、天津银行、常熟农商银行、湖南三湘银行、上海农商银行SRCB、长沙银行、无锡锡商银行等国内知名银行与金融科技机构展开合作，切实赋能金融科技。国内其他知名银行的合作也在积极接洽中。</div>
            <div class="content2">目前徕檬提供包括“移动金融服务平台”、“金融商业生态平台”、“徕檬视频中心”、“AI人工智能平台”四大产品矩阵。结合徕檬独家提供的业务定制化“运营解决方案”支持，帮助客户从系统工具到互联网运营方法论双剑合璧，一站提升。</div>
                        
            <div class="content" style="font-weight: bold">发展历程</div>
            <div class="content2">2020年3月 公司成立</div>
            <div class="content2">2020年4月 与台州银行签订移动工作站、移动营业厅、生意圈项目合作协议</div>
            <div class="content2">2020年6月 视频中心产品上线，达到银行业信息安全标准</div>
            <div class="content2">2020年7月 与蚂蚁集团达成视频中心产品项目合作</div>
            <div class="content2">2020年8月 徕檬AI团队研发虚拟机器人产品，与京东科技达成项目合作</div>
            <div class="content2">2020年9月 与多家银行签订技术服务合同</div>
            <div class="content2">2020年10月 徕檬新商业运营解决方案上线，与宁波银行签约金融直播解决方案合同</div>
            <div class="content2">2020年11月 徕檬面签SaaS产品与多家非银行客户达成合作</div>
            <div class="content2">2021年4月 与台州银行签约权益中心产品、活动中心产品、生意圈运营、生活圈运营等项目合同</div>

            <img class="img2" src="../../assets/new/newDetail_jrsyst1.png" alt="">
            <div class="content">公司愿景</div>
            <div class="content2">让金融和商业生态，更智慧、更温馨。</div>
            <div class="content1">公司使命</div>
            <div class="content2">探索前沿技术，引领业务创新。</div>
            <div class="content1">公司目标</div>
            <div class="content2">作为客户的最佳合作伙伴，提供安全、敏捷的业务应用平台。</div>
            <div class="content1">企业文化</div>
            <div class="content2">团队：谦虚谨慎、思善利他</div>
            <div class="content2">精进：客户为先、奋力前行</div>
            <div class="content2">担当：敢想敢为、舍我其谁</div>
            <div class="content1">业务构成</div>
            <div class="content1">移动金融服务平台：</div>
            <div class="content1">业务构成</div>
            <div class="content1">移动营业厅</div>
            <div class="content2">移动营业厅是客户服务渠道，是下一代的手机银行，是客户与银行接触的主要渠道，能为客户提供像在物理网点一样的、有互动的、温馨的金融和商业服务。区别于传统手机银行的自助式服务，移动营业厅主打和客户主动互动、提供温馨服务的模式，为金融机构带来组织上、产品形态上，服务体系上的变革。</div>
            <img class="img2" src="../../assets/new/newDetail_jrsyst2.png" alt="">
            <div class="content1">移动工作站</div>
            <div class="content2">移动工作站属于银行员工服务渠道。为以PAD为载体的一站式客户服务工作平台，供客户经理在“单兵”及“移动”状态下进行“获客”、“信贷”、“审批”、“营销”等业务作业，最快54秒完成开户全流程。上门服务不可或缺的高效金融生产力工具。移动⼯作站是员⼯服务渠道产品，让客户经理可以离开物理网点，像送外卖⼀样，送金融服务到客户家中。</div>
            <img class="img3" src="../../assets/new/newDetail_jrsyst3.png" alt="">
            <div class="content1">金融商业生态平台：</div>
            <div class="content1">生活圈</div>
            <div class="content2">生活圈是围绕银行的个人用户，为其满足基本生活需求场景和品质提升需求场景构建的本地特色服务平台，构建居民与“周边商圈、物业、社区、银行”五位一体的社区商业生态。</div>
            <div class="content1">生意圈</div>
            <div class="content2">生意圈是以银行服务的核心企业的管理和经营为中心，带动其下游企业客户的供应链关系，构建供应链交易场景化，管理平台化的服务体系。</div>
            <div class="content1">场景中心</div>
            <div class="content2">场景中心是在银行线上渠道生活化运营趋势下，解决多场景接入的高成本问题，一站式接入多场景化资源。</div>
            <div class="content1">流量中心</div>
            <div class="content2">一站式解决客流监测，客流转化和客流留存。支持多渠道，精准评估获客成本，提高广告投放ROI。支持多平台，Web、App、小程序、线下渠道的监测。支持全流程，从推广渠道到客流落地场景，用户的行为和业务数据的监测。在客流转化上，支持定义转化漏斗，高效定位用户流失原因。多维度可拆解的漏斗模型，让转化分析更精确。支持用户留存行为自由定义，图形化展示新用户留存模型，实现留存高效提升。</div>
            <div class="content1">活动中心</div>
            <div class="content2">一站式营销策划与活动运营中心，助力企业搭建真正的数字化全场景营销中台。提供丰富的营销活动与分析工具，支持Web端、移动端、微信小程序，APP等多种应用端同时开展营销计划。通过智慧营销重构数字营销全流程，助力企业以数据驱动业绩增长。</div>
            <div class="content1">权益中心（区块链）</div>
            <div class="content2">一站式客户运营平台，更高效，并应用区块链技术分布式管理、历史记录不可篡改，为系统的安全可靠性保驾护航，帮助商家重新定义客户全成长周期，通过用户分群，动态客户人群画像生成技术，并精细化运营，基于客户行为的实时数据，实现千人千面的自动化客户运营。为客户提供个性化的用户权益，比如：折扣，优惠券，积分，礼品，返利等等，实现客户留存、转化率快速提升，客户满意度提升的目标。</div>
            <div class="content1">徕檬视频中心：</div>
            <div class="content1">视频直播</div>
            <div class="content2">为银行及中小企业打造自己的私域视频直播平台，专注服务私域流量用户，实现转化率与营收的提升。 客户经理变身“主播”，通过视频直播宣导通识课、普及理财知识，直播“带货”，一步触达客户</div>
            <img class="img4" src="../../assets/new/newDetail_jrsyst4.png" alt="">
            <div class="content1">视频面签</div>
            <div class="content2">徕檬推出的远程签约系统，实现零摩擦业务办理，支持合同视频快速签订，可极大提升客户经理工作效率与用户体验。</div>
            <div class="content1">视频柜员</div>
            <div class="content2">打破传统物理网点对银行服务延伸的束缚，可随时随地与银行柜员联动，视频语音就可办理业务，客户体验更佳。 全业务线上办理，视频柜员多方互动一键搞定。</div>
            <div class="content1">视频会议</div>
            <div class="content2">突破距离与空间限制，随时随地组织、发起远程视频会议。无接触办公、私有化部署，会议内容（视频、音频）安全、保密。</div>
            <div class="content1">视频诊疗</div>
            <div class="content2">金融机构通过自身的资源整合，为高端客户提供名医诊疗增值服务。切合远程医疗、诊疗场景，为诊疗过程中的高清音、视频、低延迟沟通提供支持。</div>
            <div class="content1">视频面试</div>
            <div class="content2">AI虚拟机器人自动化搜索人才简历，自动化初筛、初沟通，并且实时记录候选人的情绪变化、肢体语言，回答质量等数据。综合分析，向HR团队实时反馈。</div>
            <div class="content1">视频定损</div>
            <div class="content2">适用于保险公司对车险现场进行远程定损。出险后无须定损员现场处理，只需批量上传涉险车辆、环境照片，即可完成在线报险，缩短了工单流程，节省保险公司人力成本的同时，极大提升了车险处理效率。</div>
            <div class="content1">AI人工智能平台：</div>
            <div class="content1">徕檬机器人</div>
            <div class="content2">采用虚拟柜员形象用标准动听的普通话全程引导客户完成面签，运用AI语音语义识别技术，使客户在面签过程中能够有和实际的银行真人交谈同样的流畅体验。流程中持续进行人脸检测、人脸识别、活体检测，有效进行客户身份验证，防止面签过程中可能发生的欺诈行为。</div>
            <div class="content1">虚拟形象</div>
            <div class="content2">基于真人形象建模+AI合成+语音合成匹配技术形成数字人虚拟形象，真实还原脸部特征、 表情，说话嘴型、生动自然。可在AI客服、AI视频柜员、AI数字员工和AI主播等领域代替人工办理业务，大大节约企业人工成本，加强数字化转型。</div>
            <div class="content1">语音报表</div>
            <div class="content2">通过语音识别功能协助员工制成报表，使用 NLP 技术完成贷款申请资料的录入、交叉校验、摘要生成、报表生成等。</div>
            <div class="content1">智能识图</div>
            <div class="content2">在贷款现场调查场景中，客户经理需要拍摄大量的照片进行登记、识别、入库。智能识图可对客户经理拍摄的照片进行质量评分、自动化的倾斜校正、区域裁剪等，并对客户经理拍摄各种现场照片、客户证件进行识别和分类。</div>
            <div class="content1">智能商品图/海报</div>
            <div class="content2">基于图像智能生成技术，帮助员工在短时间内完成大量banner图、海报图、商品图的设计。使用时只需输入想达成的风格、尺寸，智能商品图/海报就可代替人工进行素材分析、抠图、配色等设计工作，实时生成多种设计方案。</div>
            <div class="content1">运营解决方案</div>
            <div class="content1">金融直播运营解决方案</div>
            <div class="content2">私有化定制企业的互联网金融直播间，含服务器软硬件资源支持、直播平台后期维护、直播承制服务、直播运营支持等全流程服务。</div>
            <img class="img2" src="../../assets/new/newDetail_jrsyst5.png" alt="">
            <div class="content1">社群运营解决方案</div>
            <div class="content2">通过社群运营的方式支持全渠道获客；同时，激活银行私域流量，提升流量转化率，降低获客成本，提高用户留存率，最大化存量用户价值。</div>
            <div class="content1">互联网全栈运营解决方案</div>
            <div class="content2">通过输出全栈运营解决方案，针对性地解决中小企业、银行等在线上运营过程中遇到的实际业务问题，帮助其构建品牌形象，提升品牌音量。</div>
           

        </div>
        <Footer></Footer>
    </div>
</template>

<script>
export default {
  name: "newDetail_liul",
  data() {
    return {};
  },
  created() {
    window, scrollTo(0, 0);
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.contents {
  width: 930px;
  margin: 0px auto;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #333333;
  margin-bottom: 50px;
  .title {
    font-size: 30 * 0.75px;
    font-weight: bold;
    margin-top: 40px;
  }
  .time {
    color: #666666;
    font-size: 14 * 0.75px;
    margin-top: 10px;
  }
  .content {
    font-size: 17 * 0.75px;
    margin-top: 40px;
    line-height:1.5em;
  }
  .content1{
    font-size: 17 * 0.75px;
    margin-top: 20px;
    line-height:1.5em;
    font-weight: bold;
  }
  .content2 {
    font-size: 17 * 0.75px;
    margin-top: 10px;
    line-height:1.5em;
  }
  
  .img1 {
    width: 500 * 0.75px;
    height: 500 * 0.75px;
    margin-top: 30px;
  }
  .img2 {
    width: 704 * 0.75px;
    height: 421 * 0.75px;
    margin-top: 30px;
  }
  .img3 {
    width: 560 * 0.75px;
    height: 721 * 0.75px;
    margin-top: 30px;
  }
  .img4 {
    width: 480 * 0.75px;
    height: 721 * 0.75px;
    margin-top: 30px;
  }
}
</style>
